import { render, staticRenderFns } from "./Earth.vue?vue&type=template&id=68a35419&scoped=true"
import script from "./Earth.vue?vue&type=script&lang=ts"
export * from "./Earth.vue?vue&type=script&lang=ts"
import style0 from "./Earth.vue?vue&type=style&index=0&id=68a35419&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68a35419",
  null
  
)

export default component.exports